
// const localPath = '/src/js/pages/product/rackbuilder/temp-models'
const stagingPath = '/svc_file/staging/rck_glb'
const prodPath = '/svc_file/rackbuilder'

// On staging: useEncodedGlb is usually false — GLB paths under /svc_file/staging/ are served for testing.
// On prod: useEncodedGlb is true — encrypted .json paths are required.
const useEncodedGlb = typeof window !== 'undefined' && window.ROGUE.features.use_encrypted_glb

if (typeof window !== 'undefined' && window.ROGUE.env !== 'prod') {
  console.info(`3D models are ${useEncodedGlb ? '' : 'NOT '}encoded`)
}

export const ADJ_BENCH_3        = `${prodPath}/2024_09_18/e5d8212d.json`
export const ADJ_BENCH_4        = `${prodPath}/adj_bench_4/65dfeac2.json`
export const MANTA              = `${prodPath}/2024_09_18/25369b93.json`
export const THREE_TIER_DUMBBELL = `${prodPath}/2024_09_18/95789d9d.json`
export const FOAM_PLYO          = `${prodPath}/2024_09_18/56fb9142.json`
export const S4                 = `${prodPath}/2024_09_18/44d5cb4a.json`
export const UTILITY_BENCH      = `${prodPath}/2024_12_05/fe53214e.json`
export const BARS               = `${prodPath}/2024_12_20/b4baed58.json`
export const MONSTER_SPOTTER_ARMS = `${prodPath}/2025_02_05/b8b08f73.json`
export const CTM1_ACCESSORIES   = `${prodPath}/2025_05_16a/417cd1b1.json`
export const ATTACHMENTS        = `${prodPath}/2026_04_23/39604b72.json`
export const CTM1               = `${prodPath}/2026_04_22/b51953e9.json`
export const MMS                = `${prodPath}/2025_06_30/929ee9db.json`
export const TRAP_BAR           = `${prodPath}/trap_bar/df7d552e.json`

export const MASS_STORAGE: { [key: string]: string } = {
  PARTS: `${prodPath}/2026_07_13/21b96101.json`,
}

export const RACK_PARTS: { [key: string]: string } = {
  RM_UPRIGHTS            : `${prodPath}/rm/0a14bcc3.json`,
  RM_CROSSMEMBERS        : `${prodPath}/2026_04_13/a465b434.json`,
  RM_PULLUP              : `${prodPath}/2025_12_01/e2529037.json`,
  RM_NAMEPLATE           : `${prodPath}/2025_12_01/f3130dc3.json`,
  RM_JCUPS               : `${prodPath}/2025_10_14/4d3f23b4.json`,
  RM_SAFETY              : `${prodPath}/2025_12_01/a3e871a3.json`,
  RM_SAFETY_SPOTTER_ARMS : `${prodPath}/2025_02_05/b8b08f73.json`,
  RM_STORAGE             : `${prodPath}/2025_12_01/f5249064.json`,

  RML_UPRIGHTS            : `${prodPath}/2025_12_01/74d0a372.json`,
  RML_CROSSMEMBERS        : `${prodPath}/2025_12_01/05139603.json`,
  RML_PULLUP              : `${prodPath}/2025_10_14/61948b14.json`,
  RML_NAMEPLATE           : `${prodPath}/2025_12_01/3d36fabf.json`,
  RML_JCUPS               : `${prodPath}/2025_10_14/6692a49a.json`,
  RML_SAFETY              : `${prodPath}/2025_10_14/0025cb04.json`,
  RML_SAFETY_SPOTTER_ARMS : `${prodPath}/2025_10_14/d8599b72.json`,
  RML_STORAGE             : `${prodPath}/2026_04_20/46e7b816.json`,

  SPECIALTY_PARTS: `${prodPath}/2025_12_01/fba469d9.json`,
}

export const FXT_PARTS: { [key: string]: string } = {
  FM_TWIN_CABLES : `${prodPath}/2026_05_06/5adff31f.json`,
  FM_CABLES      : `${prodPath}/2026_05_06/6ad27700.json`,
  FML_CABLES     : `${prodPath}/2025_12_22/885ee94a.json`,
  INDY_CABLES    : `${prodPath}/2025_12_22/007eda13.json`,

  RHINO_PARTS: `${prodPath}/2026_05_06/472938ba.json`,

  FM        : `${prodPath}/2026_05_06/95089e66.json`,
  FM_SHARED : `${prodPath}/2026_05_06/1c7e6fbf.json`,
  FML       : `${prodPath}/2026_05_06/2033fab4.json`,

  FM_TWIN    : `${prodPath}/2026_05_06/35620976.json`,
  FM_TWIN_80 : `${prodPath}/2026_05_06/a0b00d77.json`,
  FML_TWIN   : `${prodPath}/2026_05_06/842763c2.json`,

  SHARED_LRLP : `${prodPath}/2026_05_06/4a8407bf.json`,
  RM_LRLP     : `${prodPath}/2025_10_14/7f594f37.json`,
  RML_LRLP    : `${prodPath}/2025_10_14/4e6125b0.json`,

  INDY    : `${prodPath}/2026_05_06/0a64ddc1.json`,
  INDY_80 : `${prodPath}/2026_05_06/495124ed.json`,

  FM_SLINGER_X     : `${prodPath}/slinger_x/0de3a109.json`,
  FML_SLINGER_X    : `${prodPath}/slinger_x/59e553a3.json`,
  SLINGER_X_SHARED : `${prodPath}/slinger_x/64c5f8c5.json`,

  RACK_ROLLERS: `${prodPath}/2026_05_06/8e0674cd.json`,
}

export const RIG_PARTS: { [key: string]: string} = {
  RM_HYBRID_LARGE    : `${stagingPath}/rm_hybrid_70_crossmember_opt.glb`,
  RM_HYBRID_HARDWARE : `${stagingPath}/hybrid_hardware_opt.glb`,

  SHARED_HYBRID_SHELVES : `${stagingPath}/hybrid_shelves_opt_v2.glb`,
  SHARED_HYBRID_ITEMS   : `${stagingPath}/hybrid_item_opt.glb`,

  RML_HYBRID_LARGE    : `${stagingPath}/rml_hybrid_large_opt.glb`,
  RML_HYBRID_HARDWARE : `${stagingPath}/rml_hybrid_hardware_opt1.glb`,
}

export const CAVE_PARTS: { [key: string]: string } = {
  CAVE_SHELVES    : `${prodPath}/2026_04_13/ca06a0d5.json`,
  CAVE_CT1        : `${prodPath}/2026_04_13/e457c083.json`,
  CAVE_LP2        : `${prodPath}/2026_04_13/9546932f.json`,
  CAVE_RM         : `${prodPath}/2026_04_22/8e32ba04.json`,
  CAVE_RM_STORAGE : `${prodPath}/2026_04_13/b4a7d3a6.json`,
  CAVE_RM_SLINGER : `${prodPath}/2026_05_04/9f4c340f.json`,
}

export const SQUAT_STANDS: { S4: string; SM: string } = {
  S4 : `${prodPath}/2024_09_18/44d5cb4a.json`,
  SM : `${prodPath}/2024_09_18/SM.json`,
}

export const SML_PARTS: { [key: string]: string } = {
  SML_COMMON_PARTS     : `${prodPath}/2025_10_14/fabe72d6.json`,
  SML_UPRIGHT_VARIANTS : `${prodPath}/2025_10_14/5156de8d.json`,
  HR2_PARTS            : `${prodPath}/2025_10_14/d931b560.json`,
}

export const WM_PARTS: { [key: string]: string } = {
  WM_RML_PARTS : `${prodPath}/2025_12_01/ad185522.json`,
  WM_SHARED    : `${prodPath}/2025_12_01/004833dd.json`,
  WM_RM_PARTS  : `${prodPath}/2025_12_01/7a013dec.json`,
  WM_90_SLIM   : `${prodPath}/2025_12_01/8a9375e1.json`,
}

export function getRackModel(line: string, mesh: string) {
  const val = RACK_PARTS[line]
  || SML_PARTS[line]
  || WM_PARTS[line]
  || CAVE_PARTS[line]
  || FXT_PARTS[line]
  || MASS_STORAGE[line]
  || RIG_PARTS[line]
  || ''

  if (!val) console.warn(`[getRackModel] missing model key "${line}" (mesh: "${mesh}") — resolves to a path with no file`)


  return `${val}#${mesh}`
}
